import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Chart, DatasetController, registerables } from 'chart.js';
import { AntEnvService, AuthService, DataService, HelperService } from '../../_services';
import * as _moment from 'moment';
import { forkJoin, Observable } from 'rxjs';
import * as M from "materialize-css/dist/js/materialize";

import jsPDF from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';

// core components
// import {
//   chartOptions,
//   parseOptions,
//   chartExample1,
//   chartExample3,
//   chartExample5,
//   chartExample6
// } from "../../variables/charts";
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import * as saveAs from 'file-saver';
import { DateTimeAdapter } from 'ng-pick-datetime';

@Component({
  selector: 'app-dashboardV02A',
  templateUrl: './dashboardV02A.component.html',
  styleUrls: ['./dashboardV02A.component.scss']
})
export class DashboardV02AComponent implements OnInit {
  @ViewChild('chtOrders', {read:null, static:false}) chtOrders: ElementRef;
  @ViewChild('chtSales', {read:null, static:false}) chtSales: ElementRef;
  @ViewChild('chtDt', {read:null, static:false}) chtDt: ElementRef;
  @ViewChild('chtTe', {read:null, static:false}) chtTe: ElementRef;
  @ViewChild('pdfTable') pdfTable!: ElementRef;

  public selectedMoment = [new Date(), new Date()]; //'Sat Nov 18 2021 00:00:00 GMT+0630 (Myanmar Time)';//new Date();
  private date = new Date();
  public compareSelectedMoment = [];

  constructor(
    private ngZone: NgZone,
    private svcAntEnv: AntEnvService,
    private svcData: DataService,
    dateTimeAdapter: DateTimeAdapter<any>,
    private router: Router
  ){
    this.date.setDate(this.date.getDate() - 7);
    this.compareSelectedMoment = [this.date, this.date];
    //dateTimeAdapter.setLocale('en-IN');
    Chart.register(...registerables);
  }
  client = '';
  pageData = {
    account: {
      //fullName: '', email: '', password: '', confirmPassword: '', contactNo: '', imageUrl: '', role: 'ADMIN', title: ''
      fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    userList: [], areas:[], areas4Occupancy:[],
    areaIndex: -1, inValue: 0, outValue: 0, occupancyValue: 0,
    data: [], hourlyDtd:[],
    cDataEntry: [], cDataExit: [], cDataOccupancy: [], cHourlyDTD: [], cTopSensorData: [], cSensorUuid: [],
    cDTRangeData: [],
    cHisEntry:[], cHisExit: [], cHisOccupancy: [], cHisTopSensorData: [], cHisDTRangeData: [],
    autoRefresh: false, isToday: false, maxOccupancy: 0
  }


  formats = [
    {title: 'Hourly', value: 'HOURLY'},
    {title: 'Daily', value: 'DAILY'},
    {title: 'Weekly', value: 'WEEKLY'},
    {title: 'Monthly', value: 'MONTHLY'}
  ];
  formatSelected: any = {title: 'Hourly', value: 'HOURLY'};

  dataHis = {
    data: [], peakHourTitle: '-',
    inValue: 0, outValue: 0, maxOccupancy: 0
  };

  isLoading = true;
  public datasets: any;
  public data: any; dataLevel4 = []; exportData = []; hisDataLevel = [];
  public salesChart;
  public clicked: boolean = true;
  public clicked1: boolean = false;
  isLoadingOccupancy = false;
  area:any;
  chtEntry:any;
  chtExit:any;
  chtOccupancy:any;
  chtHourlyDwellTime:any;
  peakHourTitle = '-';
  dwelltimeMinute = 0;
  dwelltimeMinuteLastWeek = 0;
  isShowDTD = false;
  his: Array<number>;
  ordersChart: any;
  teCharts: any;
  dtChart: any;
  teChart: any;
  public arrHr: any = [];
  lDate: any = [];
  compareDate: any = [];
  _hisAreaDetail: any = [];

  
  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }

  ngOnInit() {
    if(this.svcData.dsDateParam.length != 0){
      this.selectedMoment = this.svcData.dsDateParam;
      this.svcData.dsDateParam = [];
    }

    if(this.svcData.dsCompareDateParam.length != 0){
      this.compareSelectedMoment = this.svcData.dsCompareDateParam;
      this.svcData.dsCompareDateParam = [];
    }

    this.svcAntEnv.load().subscribe(res=>{
      if(res.client != null){
          this.client = res.client;
      }
    });

    this.areaListLoad();
    
    

    this.datasets = [
      [0, 20, 10, 30, 15, 40, 20, 60, 60],
      [0, 20, 5, 25, 10, 30, 15, 40, 40]
    ];
    this.data = this.datasets[0];
    this.dataLevel4 = [];
    this.exportData = [];
    this.hisDataLevel = [];

    var _self = this;
    window.setInterval(
      function(){ 
        if(_self.pageData.autoRefresh){
          console.log('auto-refresh');
          _self.dataLoad();
        }
      },
      (environment.autoRefreshSec*1000)
    );

    window.setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
    }, 500);
    

    // parseOptions(Chart, chartOptions());

  }

  formatSelect(arg){
    this.formatSelected = arg;  
    this.svcData.dsDateParam = this.selectedMoment;
    this.svcData.dsCompareDateParam = this.compareSelectedMoment;
    if(arg.title == "Daily"){
      this.router.navigate(['/dashboardV02AD'])
    }
    if(arg.title == "Weekly"){
      this.router.navigate(['/dashboardV02AW'])
    }
    if(arg.title == "Monthly"){
      this.router.navigate(['/dashboardV02AM'])
    }
  }


  public downloadAsPDF(chtName:string) {
    const canvas = <HTMLCanvasElement> document.getElementById(chtName);
    const tblSkill = document.getElementById('pdf'+chtName);
    const canvasImage = canvas.toDataURL('image/jpeg', 1.0);
    
    let pdf = new jsPDF('landscape');
    pdf.setFontSize(12);
    pdf.setFillColor(255,153,0,1);
    //pdf.rect(10, 10, 150, 160, "F");
    //console.log(canvas.width);
    pdf.addImage(canvasImage, 'png', 5, 5, tblSkill.clientWidth*0.15, canvas.height*0.2);
    pdf.save(chtName+'.pdf');      
  }

  // public downloadAsPDFPie(chtName:string) {
  //   const canvas = <HTMLCanvasElement> document.getElementById(chtName);
  //   const tblSkill = document.getElementById('pdf'+chtName);
  //   const canvasImage = canvas.toDataURL('image/jpeg', 1.0);
    
  //   let pdf = new jsPDF('landscape');
  //   pdf.setFontSize(12);
  //   pdf.setFillColor(255,153,0,1);
  //   //pdf.rect(10, 10, 150, 160, "F");
  //   //console.log(canvas.width);
  //   pdf.addImage(canvasImage, 'png', 5, 5, tblSkill.clientWidth*0.15, canvas.height*0.2);
  //   pdf.save(chtName+'.pdf');      
  // }

  downloadTblAsPDF() {
    const pdfTable = this.pdfTable.nativeElement;
    var html = htmlToPdfmake(pdfTable.innerHTML);
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition).download(); 
     
  }

  dateChange(args){
    this.svcData.dsDateParam = args;
    this.dataLoad();
  }
  compareDateChange(args){
    this.svcData.dsCompareDateParam = args;
    this.dataLoad();
  }

  chartIntervals(openingTime, closingTime){
    var _arrHr = [];
    var _startHour = _moment(openingTime).hour();
    var _endHour = _moment(closingTime).hour();
    if(_endHour==0) _endHour = 23;
    for(var i=_startHour;i<=_endHour;i++){
      _arrHr.push(i + ':00');
    }
    return _arrHr;
  }

  areaListLoad(){
    this.svcData.areaListForDashboard().subscribe(res=>{
      if(res.status != 'OK'){
        //this.showAlert(res.message);
        return;
      }
      this.pageData.areas = res.data;
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      this.areaSelect(this.pageData.areas[0]);
      setTimeout(function(){
        M.FormSelect.init(document.querySelectorAll('select'), {classes:'ddl-001'});
      }, 3000);
    });
  }

  dataLoad(){
    this.loading(true);
    this.svcData.areaDetail(this.area.areaId).subscribe(res=>{
      if(res.status != 'OK'){
        //this.showAlert(res.message);
        return;
      }
      var _areaDetail = res.data;
      this._hisAreaDetail = res.data;
      var _startTime = _moment(this.selectedMoment[0]).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      var _endTime = _moment(this.selectedMoment[1]).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
      
      var _hisStartTime = _moment(this.compareSelectedMoment[0]).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      var _hisEndTime = _moment(this.compareSelectedMoment[1]).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
      this.pageData.isToday = _startTime == _moment().format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      this.pageData.maxOccupancy = 0;
      var _startTimeLastWeek = _moment(this.selectedMoment[0]).subtract(7,'d').format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');

      this.arrHr = this.chartIntervals(this.area.openingTime, this.area.closingTime);
      
      this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
        this.loading(false);
        if(res.status != 'OK'){
          console.log('sensor data error### ' + this.area.areaId);
          //this.showAlert(res.message);
          return;
        }
        this.pageData.inValue = 0;
        this.pageData.outValue = 0;
        this.pageData.data = res.data;
        //console.log(this.pageData.data);
  
        this.pageData.cDataEntry = [];
        this.pageData.cDataExit = [];
        this.pageData.cDataOccupancy = [];
        this.dataLevel4 = [];
        this.exportData = [];
        
        var cHour = _moment().hour();
        
        var _openingHour = _moment(this.area.openingTime).hour();
        this.pageData.data.forEach(x=>{
          if(_moment(x.timestamp).hour() >= _openingHour && _moment(x.timestamp).hour() <= _moment(this.area.closingTime).hour()){
            this.pageData.inValue +=  x.inValue;
            this.pageData.outValue += x.outValue;
            
            var iHour = _moment(x.timestamp).hour()-_openingHour;
            if(this.pageData.isToday && iHour>cHour){
              this.pageData.cDataEntry[iHour] = null;
              this.pageData.cDataExit[iHour] = null;
            }
            else{
              this.pageData.cDataEntry[iHour] = x.inValue;
              this.pageData.cDataExit[iHour] = x.outValue;
            }
          }
        });
        
        if(this.pageData.inValue<this.pageData.outValue){
          this.pageData.outValue = this.pageData.inValue;
        }
        var _occupancy = 0;
        this.pageData.cDataEntry.forEach((x, iX)=>{
          //if(iX < 7)
          this.dataLevel4[iX] = {h:(9+iX).toString()+':00', t:x, o:0, hh:'', ht:0, ho:0};
          this.exportData[iX] = {h:(9+iX).toString()+':00', t:x, o:0, hh:'', ht:0, ho:0}; // for export
          if(x==null && this.pageData.cDataExit[iX]==null) return;
          _occupancy += x - this.pageData.cDataExit[iX];
          if(_occupancy<0) _occupancy = 0;
          if(this.pageData.isToday && cHour<iX) _occupancy = null;
          this.pageData.cDataOccupancy[iX] = _occupancy;
          //if(iX < 7)
          this.dataLevel4[iX].o = _occupancy;
          this.exportData[iX].o = _occupancy;
          if(_occupancy>this.pageData.maxOccupancy) this.pageData.maxOccupancy = _occupancy;
        })
        //console.log(this.dataLevel4);
        this.chartSalesBind();
        this.chartOrdersBind(this.dataLevel4);
        if(this.pageData.occupancyValue<0) this.pageData.occupancyValue = 0;
  
        this.dataLoadHistory(_areaDetail);
        //this.loadHourlyDwellTimeData(_startTime, _endTime, this.area.areaId);
        this.dataLoadPeakHour();
          //  this.loadDwellTimeData(_startTime);
          // this.loadDwellTimeDataLastWeek(_startTimeLastWeek);

        
         //this.loadHourlyRangeDwellTimeData(this.area.areaId, _startTime, _endTime, _hisStartTime, _hisEndTime);

        this.loadTopSensorData(this.area.areaId, _startTime, _endTime, _hisStartTime, _hisEndTime);

        if(!this.pageData.isToday){
          this.pageData.outValue = this.pageData.inValue;
          this.pageData.occupancyValue = 0;
        }
      });
      if(this.pageData.isToday){
        this.dataLoad4Occupancy();
      }
      else{
        this.pageData.areas4Occupancy = [];
      }
    });
  }

  areaSelect(arg){
    this.area = arg;
    this.dataLoad();
  }

  areaSelectDdl(arg){
    var _arr = this.pageData.areas.filter(x=>x.areaName == arg);
    if(_arr.length<1){
      alert('Area not found ' + arg);
      return;
    }
    this.areaSelect(_arr[0]);
  }

  dataLoadHistory(_areaDetail){
    var _startTime = _moment(this.compareSelectedMoment[0]).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
    var _endTime = _moment(this.compareSelectedMoment[1]).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
    this.dataHis.inValue = 0;
    this.dataHis.outValue = 0;
    this.dataHis.maxOccupancy = 0;
    this.dataHis.peakHourTitle = '-';
    var _maxIn = 0;
    var _occupancy = 0;
    this.pageData.cHisEntry = [];
    this.hisDataLevel = [];
    this.pageData.cHisExit = [];
    this.pageData.cHisOccupancy = [];

    this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
      this.pageData.cHisEntry = [];
      this.hisDataLevel = [];
      if(res.data.length == 0 || res.status != 'OK'){
        //this.showAlert(res.message);
        this.chartOrdersBind(this.dataLevel4);
        return;
      }
      this.dataHis.data = res.data;
      var _openingHour = _moment(this.area.openingTime).hour();

      this.dataHis.data.forEach((d,iX)=>{
        if(_moment(d.timestamp).hour() >= _openingHour && _moment(d.timestamp).hour() <= _moment(this.area.closingTime).hour()){
        this.dataHis.inValue += d.inValue;
        this.dataHis.outValue += d.outValue;
        if(d.inValue > _maxIn){
          _maxIn = d.inValue;
          this.dataHis.peakHourTitle = _moment(d.timestamp).format('hh A');
        }
        _occupancy += d.inValue - d.outValue;
        if(_occupancy<0) _occupancy = 0;
        if(_occupancy>this.dataHis.maxOccupancy) this.dataHis.maxOccupancy = _occupancy;

        this.pageData.cHisEntry.push(d.inValue);
        this.hisDataLevel.push({h:(9+iX).toString()+':00', t:d.inValue, o:_occupancy});
        this.pageData.cHisExit.push(d.outValue);
        this.pageData.cHisOccupancy.push(_occupancy); 
      }       
      });
      if(this.dataHis.inValue<this.dataHis.outValue){
        this.dataHis.outValue = this.dataHis.inValue;
      }
        if(this.hisDataLevel != null){
          this.hisDataLevel.forEach((hd,iX) => {
            if(iX < this.dataLevel4.length && this.dataLevel4.length != 0){
              this.dataLevel4[iX].hh = hd.h;
              this.dataLevel4[iX].ht = hd.t;
              this.dataLevel4[iX].ho = hd.o;
              this.exportData[iX].hh = hd.h;
              this.exportData[iX].ht = hd.t;
              this.exportData[iX].ho = hd.o;
            }
          })
        }

         this.chartOrdersBind(this.dataLevel4);
    });    
  }

  dataLoadPeakHour(){
    this.peakHourTitle = '-';
    var _maxIn = 0;
    this.pageData.data.forEach(d=>{
      if(d.inValue > _maxIn){
        _maxIn = d.inValue;
        this.peakHourTitle = _moment(d.timestamp).format('hh A');
      }
    });
  }

  loadHourlyDwellTimeData(startTime, endTime, areaId){
    this.svcData.hourlyDwellTimeData(startTime, endTime, areaId).subscribe(hdw=>{
      this.pageData.hourlyDtd = hdw.data;
      this.pageData.hourlyDtd.forEach(x=>{
        this.pageData.cHourlyDTD.push(x.dwellTimeMinute/60);
      })
    });
  }

  loadDwellTimeData(startTime: any){
    this.svcData.getDwellTimeData(startTime).subscribe(dw=> {
      if(dw.status != 'OK'){
        //this.showAlert(dw.message);
        return;
      } 
        if(dw.data.length>0){
          this.dwelltimeMinute = dw.data[0].dwellTimeMinute;
        }
      
    })
  }

  loadDwellTimeDataLastWeek(startTime: any){
    this.svcData.getDwellTimeDataLastWeek(startTime).subscribe(dw=> {
      if(dw.status != 'OK'){
        //this.showAlert(dw.message);
        return;
      }   
      if(dw.data.length>0){   
      this.dwelltimeMinuteLastWeek = dw.data[0].dwellTimeMinute;
      }
    })
  }

  dataLoad4Occupancy(){
    this.pageData.areas4Occupancy = [];
    this.svcData.areaListForOccupancy().subscribe(res=>{
      if(res.status != 'OK'){
        //this.showAlert(res.message);
        return;
      }
      this.pageData.areas4Occupancy = res.data;

      var _arrReq:Observable<any>[] = [];
      this.pageData.areas4Occupancy.forEach(rec=>{
        rec.occupancyTitle = '-';
        var _startTime = _moment(this.selectedMoment[0]).format('YYYYMMDD') + _moment(rec.openingTime).format('HHmmss');
        var _endTime = _moment(this.selectedMoment[1]).format('YYYYMMDD') + _moment(rec.closingTime).format('HHmmss');
        _arrReq.push(this.svcData.sensorData(rec.areaId, _startTime, _endTime));
      });
      this.isLoadingOccupancy = true;
      forkJoin(_arrReq).subscribe(resArr=>{
        this.isLoadingOccupancy = false;
        resArr.forEach((resOccupancy, i)=>{
          if(resOccupancy.status != 'OK'){
            //this.showAlert(resOccupancy.message);
            return;
          }
          var _areaOccupancy = 0;
          var _dataOccupancy = resOccupancy.data;

          this.pageData.areas4Occupancy[i].inTotal = 0;
          this.pageData.areas4Occupancy[i].outTotal = 0;
          _dataOccupancy.forEach(x=>{
            _areaOccupancy += x.inValue - x.outValue;
            this.pageData.areas4Occupancy[i].inTotal += x.inValue;
            this.pageData.areas4Occupancy[i].outTotal += x.outValue;
            if(_areaOccupancy<0) _areaOccupancy = 0;
          });
          this.pageData.areas4Occupancy[i].occupancy = _areaOccupancy;
          this.pageData.areas4Occupancy[i].occupancyTitle = _areaOccupancy;
        });
        if(this.client == 'DM'){
          if(this.pageData.areas4Occupancy[0].occupancy<=0 && this.pageData.areas4Occupancy[0].inTotal>0){
            this.pageData.areas4Occupancy[0].occupancy = Math.round(this.pageData.areas4Occupancy[0].inTotal*0.01);
            this.pageData.areas4Occupancy[0].occupancyTitle = this.pageData.areas4Occupancy[0].occupancy;
          }
        }
        else if(this.client == 'TB'){
          var _occBD = this.pageData.areas4Occupancy[0].occupancy;
          var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // MH
          var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // R
          var _occ3 = this.pageData.areas4Occupancy[3].occupancy; // SR
          this.pageData.areas4Occupancy[0].occupancy = _occ1+_occ2+_occ3;
          this.pageData.areas4Occupancy[0].occupancyTitle = _occ1+_occ2+_occ3;
          this.pageData.areas4Occupancy[1].occupancyTitle = _occ1;
          this.pageData.areas4Occupancy[2].occupancyTitle = _occ2;
          this.pageData.areas4Occupancy[3].occupancyTitle = _occ3;
          console.log('occupancy TB loaded>>>>', this.pageData.areas4Occupancy[0]);
        }
      })
    });
  }

  

  loadTopSensorData(areaId: any, startTime: any, endTime: any,_hisStartTime: any, _hisEndTime: any){
    this.pageData.cTopSensorData = [];
    this.pageData.cSensorUuid = [];
    this.svcData.getTopSensorData(areaId,startTime, endTime).subscribe(res=>{
      if(res.status != 'OK'){
        return;
      }
      if(res.data.length>0){
        this.pageData.cTopSensorData = [];
        this.pageData.cSensorUuid = [];
        res.data.forEach(x => {
          this.pageData.cTopSensorData.push(x.inValue);
          this.pageData.cSensorUuid.push(x.sensor.sensorUuid).toString();
        });
        //this.chartTopEntrancesBind();
        this.loadHisTopSensorData(this.pageData.cTopSensorData, areaId,startTime, endTime, _hisStartTime, _hisEndTime);        
      }
    })
  }

  loadHisTopSensorData(cTopSensorData: any, areaId: any, startTime: any, endTime: any, hisStartTime: any, hisEndTime: any){
    this.pageData.cHisTopSensorData = [];
    this.svcData.getHisTopSensorData(areaId,startTime, endTime, hisStartTime, hisEndTime).subscribe(res=>{
      if(res.status != 'OK'){
        return;
      }
      if(res.data.length>0){
        this.pageData.cHisTopSensorData = [];
        res.data.forEach(x => {
          this.pageData.cHisTopSensorData.push(x.inValue);
        });
      }
      this.chartTopEntrancesBind(cTopSensorData);      
    })
  }

  loadHourlyRangeDwellTimeData(areaId: any, startTime: any, endTime: any, hisStartTime: any, hisEndTime: any){
    this.pageData.cDTRangeData = [];
    var _3to5personCount = 0, _5to10personCount = 0, _10to20personCount = 0, _20to30personCount = 0, _30pluspersonCount = 0;
    this.svcData.getHourlyRangeDwellTimeList(areaId,startTime, endTime).subscribe(res=>{
      if(res.status != 'OK'){
        return;
      }
      if(res.data.length>0){
        res.data.forEach(a => {
          if(a.dwellTimeMinutes.totalMinutes >= 3 && a.dwellTimeMinutes.totalMinutes <= 5){
            _3to5personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes >= 5 && a.dwellTimeMinutes.totalMinutes <= 10){
            _5to10personCount += a.personCount;
          } 
          if(a.dwellTimeMinutes.totalMinutes >= 10 && a.dwellTimeMinutes.totalMinutes <= 20){
            _10to20personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes >= 20 && a.dwellTimeMinutes.totalMinutes <= 30){
            _20to30personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes > 30){
            _30pluspersonCount += a.personCount;
          }         
        });
        this.pageData.cDTRangeData.push(_3to5personCount);
        this.pageData.cDTRangeData.push(_5to10personCount);
        this.pageData.cDTRangeData.push(_10to20personCount);
        this.pageData.cDTRangeData.push(_20to30personCount);
        this.pageData.cDTRangeData.push(_30pluspersonCount);

        this.loadHisHourlyRangeDwellTimeData(areaId, hisStartTime, hisEndTime);
        //this.chartDwellTimeBind();

      }
    })
  }

  loadHisHourlyRangeDwellTimeData(areaId: any, startTime: any, endTime: any){
    this.pageData.cHisDTRangeData = [];
    var _3to5personCount = 0, _5to10personCount = 0, _10to20personCount = 0, _20to30personCount = 0, _30pluspersonCount = 0;
    this.svcData.getHourlyRangeDwellTimeList(areaId,startTime, endTime).subscribe(res=>{
      if(res.status != 'OK'){
        return;
      }
      if(res.data.length>0){
        res.data.forEach(a => {
          if(a.dwellTimeMinutes.totalMinutes >= 3 && a.dwellTimeMinutes.totalMinutes <= 5){
            _3to5personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes >= 5 && a.dwellTimeMinutes.totalMinutes <= 10){
            _5to10personCount += a.personCount;
          } 
          if(a.dwellTimeMinutes.totalMinutes >= 10 && a.dwellTimeMinutes.totalMinutes <= 20){
            _10to20personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes >= 20 && a.dwellTimeMinutes.totalMinutes <= 30){
            _20to30personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes > 30){
            _30pluspersonCount += a.personCount;
          }         
        });
        this.pageData.cHisDTRangeData.push(_3to5personCount);
        this.pageData.cHisDTRangeData.push(_5to10personCount);
        this.pageData.cHisDTRangeData.push(_10to20personCount);
        this.pageData.cHisDTRangeData.push(_20to30personCount);
        this.pageData.cHisDTRangeData.push(_30pluspersonCount);
      }
      //this.chartDwellTimeBind();
    })
  }

  dataExportCsv() {
    var _nl = '\r\n';
    var csv = 'FROM DATE RANGE '+_moment(this.selectedMoment[0]).format('D/MM/YYYY') + ' - '+ _moment(this.selectedMoment[1]).format('D/MM/YYYY')+ ' TO DATE RANGE '+_moment(this.compareSelectedMoment[0]).format('D/MM/YYYY') + ' - '+ _moment(this.compareSelectedMoment[1]).format('D/MM/YYYY') +',';
    csv += "Hour" + ',';
    csv += "Traffic" + ',';
    csv += "Occupancy" + ',';
    csv += "Compare Hour" + ',';
    csv += "Compare Traffic" + ',';
    // csv += "Avg Dwell Time" + ',';
    csv += _nl;
    this.exportData.forEach(s => {
      csv += _nl + ',' + s.h + ','+`${s.t},`+ `${s.o},`+ `${s.hh},`+ `${s.ht},`;
    });
    var blob = new Blob([csv], {type: 'text/csv' })
    saveAs(blob, "exportData.csv");

  }

  public updateOptions() {
    this.salesChart.data.datasets[0].data = this.data;
    this.salesChart.update();
  }

  chartOrdersBind(dataLabel: any){

    // const footer = (tooltipItems) => {
    //   let sum1, sum2 = 0;
    //   let lbl1, lbl2 = "";
    
    //   //tooltipItems.forEach(function(tooltipItem) {
    //     sum1 = tooltipItems[0].parsed.y;
    //     lbl1 = tooltipItems[0].label;
    //     sum2 = tooltipItems[1].parsed.y;
    //     lbl2 = tooltipItems[1].label;
    //   //});
    //   //this.dataLevel4
    //   return lbl1 +': '+sum1+' , '+lbl2 +': '+sum2;
    // };

    var _hover = { mode: 'nearest', intersect: true };
    var _tooltip = { mode: 'index', intersect: false };
    var _pluginsLegendTooltip:any = {
      legend: { display:false },
          tooltip: { mode: 'index', intersect: false }
    };
    //var arrHr = this.chartIntervals(this.area.openingTime, this.area.closingTime);
    const bgColor = {
      id: 'bgColor',
      beforeDraw: (chart, options) => {
        const { ctx, width, height } = chart;
        ctx.fillStyle = 'white';
        ctx.fillRect(0,0,width,height);
        ctx.restore();
      }
    }
    
    var _borderColorH = "rgba(224,224,224,0.5)", _bgColorH = 'rgba(31,41,21,0.3)'; //'rgba(117,117,117,0.1)';
    var _lblToday = 'Today', _lblLastWeek = 'Last Week', _borderHDash = [5,5];
    var _pointBorderColorH = "rgba(224,224,224,1)";

    const chartOrders =  this.chtOrders.nativeElement.getContext('2d'); //document.getElementById('chart-orders');
    if(this.ordersChart != null) this.ordersChart.destroy();
    this.ordersChart = new Chart(chartOrders, {
      type: 'line',

      // options:{
      //   plugins:{
      //     tooltip: {
      //       //enabled: false,            
      //       callbacks: {
      //         label(this, tooltipItem) {
      //           var _d = datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
      //           return _d.x + ': ' + _d.y;
      //         },
      //       }
      //     }
      //   },
      //   maintainAspectRatio: false
      // },

      // options: {
      //   plugins: _pluginsLegendTooltip, //hover: _hover, tooltips: _tooltip, legend: { display: false },
      //   maintainAspectRatio: false,
      //   scales: {
      //     //xAxes: [{ display: true }], yAxes: [{ display: true }],
      //   },
      // },
      plugins: [bgColor],
      data: {
        labels: this.arrHr,
        datasets: [
          { 
            data: this.pageData.cDataEntry, //[{x: "99:00", y: 127}, {x: "100:00", y: 140},{x: "120:00", y: 135},{x: "130:00", y: 122}], //['data 1','data 2', 'data 3','data 4', 'data 5','data 6', 'data 7','data 8', 'data 9','data 10', 'data 11','data 12', 'data 13','data 14'], //this.pageData.cDataEntry, 
            label: "Traffic", fill: true, tension: 0.5, 
            //backgroundColor : "rgba(3,169,244,0.6)", pointBorderColor:'#fff',
            backgroundColor: "rgba(33,150,243,0.2)", borderColor: "#90caf9", pointBorderColor: '#90caf9' 
          },
          { 
            data: this.pageData.cHisEntry, label: "Last Traffic", fill: true, tension: 0.5, borderDash: _borderHDash,
            backgroundColor : _bgColorH, borderColor: _borderColorH, pointBorderColor: _pointBorderColorH //pointBorderColor:'rgba(3,169,244,0.6)',
          },
        ]
      },
      options:{
        plugins:{
         tooltip: {
           mode: 'index', 
           intersect: false,
           callbacks:{
           label(this, tooltipItem) {
             if(tooltipItem.datasetIndex == 0)return dataLabel[tooltipItem.dataIndex].h +': '+dataLabel[tooltipItem.dataIndex].t;
             if(tooltipItem.datasetIndex == 1)return dataLabel[tooltipItem.dataIndex].hh +': '+dataLabel[tooltipItem.dataIndex].ht;
           }
          }
         }
        },       
       maintainAspectRatio: false
     },
      
    });
  }

  chartSalesBind(){
    var colors = {
      gray: {
        100: '#f6f9fc',
        200: '#e9ecef',
        300: '#dee2e6',
        400: '#ced4da',
        500: '#adb5bd',
        600: '#8898aa',
        700: '#525f7f',
        800: '#32325d',
        900: '#212529'
      },
      theme: {
        'default': '#172b4d',
        'primary': '#5e72e4',
        'secondary': '#f4f5f7',
        'info': '#11cdef',
        'success': '#2dce89',
        'danger': '#f5365c',
        'warning': '#fb6340'
      },
      black: '#12263F',
      white: '#FFFFFF',
      transparent: 'transparent',
    };

    const bgColor = {
      id: 'bgColor',
      beforeDraw: (chart, options) => {
        const { ctx, width, height } = chart;
        ctx.fillStyle = 'white';
        ctx.fillRect(0,0,width,height);
        ctx.restore();
      }
    }
    const chartSales = this.chtSales.nativeElement.getContext('2d'); //document.getElementById('chart-sales');
    if(this.salesChart != null) this.salesChart.destroy();
    this.salesChart = new Chart(chartSales, {
			type: 'line',
			options: {
        maintainAspectRatio: false,
      },
      plugins: [bgColor],
      data: {
        labels: this.arrHr,//['07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'],
        datasets: [
          { label: 'Occupancy', data: this.pageData.cDataOccupancy, borderColor: 'rgba(29,233,182,0.7)' }, //yAxisID: 'y-axis-1' },
          { label: 'Entry', type: 'bar', data: this.pageData.cDataEntry, backgroundColor: 'rgba(31,41,21,0.3)'} //'rgba(0, 0, 0,0.25)' }
        ]
      }
		});
  }

  chartTopEntrancesBind(cTopSensorData: any){   
    
    const bgColor = {
      id: 'bgColor',
      beforeDraw: (chart, options) => {
        const { ctx, width, height } = chart;
        ctx.fillStyle = 'white';
        ctx.fillRect(0,0,width,height);
        ctx.restore();
      }
    }

    const chartTe = this.chtTe.nativeElement.getContext('2d'); //document.getElementById('chart-sales'); 
    var canvas = document.getElementById('chtTe'); 
    // chartTe.canvas.parentNode.style.height = '700px';
    // chartTe.canvas.parentNode.style.width = '700px';
    //chartTe.canvas.parentNode.style = 'margin-left: 19px;';
    if(this.teChart != null) this.teChart.destroy();
    this.teChart = new Chart(chartTe, {
      type: 'pie',
      options: //chartExample2.optionsBarHorizonal,
      {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins:{
          legend:{
            position: 'right'
          }
        }
      },
      plugins: [bgColor],
      data: {
        labels: this.pageData.cSensorUuid,
        datasets: [
          {
            label: "Traffic",
            data: cTopSensorData,
            backgroundColor: '#d500f9',
            indexAxis: 'y',
          },
          {
            label: "Last Week ",
            data: this.pageData.cHisTopSensorData,
            backgroundColor: 'rgba(249, 231, 159 )', //'rgba(31,41,21,0.3)', //'rgba(211,211,211,0.2)',
            indexAxis: 'y',
          },
        ]
      },
    });
  }

  // chartDwellTimeBind(){
  //   const chartDt = this.chtDt.nativeElement.getContext('2d'); //document.getElementById('chart-sales');
  //   if(this.dtChart != null) this.dtChart.destroy();
  //   this.dtChart = new Chart(chartDt, {
  //     type: 'horizontalBar',
  //     options: //chartExample5.optionsBarHorizonal,
  //     {
  //       indexAxis: 'y',
  //     },
  //     data: {
  //       labels: ["(3-5) Min", "(5-10) Min", "(10-20) Min", "(20-30) Min", "(30+) Min"],
  //       datasets: [
  //         {
  //           label: "Traffic", 
  //           data: this.pageData.cDTRangeData,
  //           backgroundColor: '#d500f9',
  //           axis: 'y',
  //           //xAxisID: 'x-axis-2'
  //         },
  //         {
  //           label: "Last Week ",
  //           data: this.pageData.cHisDTRangeData,
  //           backgroundColor: 'rgba(211,211,211,0.2)',
  //           axis: 'y',
  //           //xAxisID: 'x-axis-2'
  //         },
  //       ]
  //     },
  //   });
  // }


// bindTestChart(){
//   var _labels = ['25 Jun', '24 Jun', '23 Jun'];
//   var _data = {
//     datasets: [
//       {data: [{x:'Traffic', y:20}, {x:'Traffic', y:15},{x:'Traffic', y:21}], label:'Current', borderColor: 'rgb(75, 192, 192)'},
//       {data: [{x:'18 Jun', y:18}, {x:'17 Jun', y:22}, {x:'16 Jun', y:15}], label:'Compare', borderColor:'red'}
//     ],
//     labels: _labels
//   };
//   var config = {
//     type: 'line',
//     data: _data,
//     options:{
//       tooltips: {
//         mode: 'index',
//         intersect: false,
//         callbacks: {
//           label: function(tooltipItem, argData) {
//             var _d = argData.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
//             return _d.x + ': ' + _d.y;
//           }
//         }
//       }
//     }
//   };
//   //var ctx = document.getElementById("canvas").getContext("2d");
//   var ctx = this.chtOrders.nativeElement.getContext("2d");
//   var myLine = new Chart(ctx, config);
// }

}

